import { OpenBookContext } from "../contexts/OpenBookScope";
import React from "react";

export const useOpenBookScopeContext = () => React.useContext(OpenBookContext);
